// @module Tavanoteam.Calculator.Calculator
define('Calculator.CubicFoot.Form.View'
    , [
        'calculator_cubic_foot_form.tpl'

        , 'Backbone'
        , 'jQuery'
    ]
    , function (
        calculator_cubic_foot_form_tpl

        , Backbone
        , jQuery
    ) {
        'use strict';

        return Backbone.View.extend({

            template: calculator_cubic_foot_form_tpl

            , initialize: function (options) {
                
                this.isSphere = options.isSphere;
                this.isCone = options.isCone;
                this.isCube = options.isCube;
                this.isCylinder = options.isCylinder;
                this.isRectangular = options.isRectangular;
                this.isCapsule = options.isCapsule;
                this.isSpherical = options.isSpherical;
                this.isConical = options.isConical;
                this.isEllipsoid = options.isEllipsoid;
                this.isSquare = options.isSquare;
                this.isTube = options.isTube;
                this.isSlope = options.isSlope;

            }

            , events: {
                'click [data-action="calculate-cubic-foot-sphere"]': 'calculateSphereVolume',
                'click [data-action="calculate-cubic-foot-cone"]': 'calculateConeVolume',
                'click [data-action="calculate-cubic-foot-cube"]': 'calculateCubeVolume',
                'click [data-action="calculate-cubic-foot-cylinder"]': 'calculateCylinderVolume',
                'click [data-action="calculate-cubic-foot-rectangular"]': 'calculateRectangularVolume',
                'click [data-action="calculate-cubic-foot-capsule"]': 'calculateCapsuleVolume',
                'click [data-action="calculate-cubic-foot-spherical"]': 'calculateSphericalVolume',
                'click [data-action="calculate-cubic-foot-conical"]': 'calculateConicalVolume',
                'click [data-action="calculate-cubic-foot-ellipsoid"]': 'calculateEllipsoidVolume',
                'click [data-action="calculate-cubic-foot-square"]': 'calculateSquareVolume',
                'click [data-action="calculate-cubic-foot-tube"]': 'calculateTubeVolume',
                'click [data-action="calculate-cubic-foot-slope"]': 'calculateSlopeVolume',
                'click [data-action="reset"]': 'resetAllFields'

            }

            , calculateSphereVolume: function calculateSphereVolume() {
                //input fields
                var radius = $('#cubic-foot-sphere-radius').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = Math.PI * (Math.pow(radius,3))*(4/3);

                volume.val(result.toFixed(2));
            }

            , calculateConeVolume: function calculateConeVolume() {
                //input fields
                var radius = $('#cubic-foot-cone-radius').val();
                var height = $('#cubic-foot-cone-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = (1/3) * Math.PI * (Math.pow(radius,2)) * height;

                volume.val(result.toFixed(2));
            }

            , calculateCubeVolume: function calculateCubeVolume() {
                //input fields
                var length = $('#cubic-foot-cube-length').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = Math.pow(length,3);

                volume.val(result.toFixed(2));
            }

            , calculateCylinderVolume: function calculateCylinderVolume() {
                //input fields
                var radius = $('#cubic-foot-cylinder-radius').val();
                var height = $('#cubic-foot-cylinder-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = Math.PI * Math.pow(radius,2) * height;

                volume.val(result.toFixed(2));
            }

            , calculateRectangularVolume: function calculateRectangularVolume() {
                //input fields
                var length = $('#cubic-foot-rectangular-length').val();
                var width = $('#cubic-foot-rectangular-width').val();
                var height = $('#cubic-foot-rectangular-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = length * width * height;

                volume.val(result.toFixed(2));
            }

            , calculateCapsuleVolume: function calculateCapsuleVolume() {
                //input fields
                var radius = $('#cubic-foot-capsule-radius').val();
                var height = $('#cubic-foot-capsule-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = ((4/3) * Math.PI * Math.pow(radius,3)) + (Math.PI * Math.pow(radius,2) * height);

                volume.val(result.toFixed(2));
            }

            , calculateSphericalVolume: function calculateSphericalVolume() {
                //input fields
                var radius = $('#cubic-foot-spherical-radius').val();
                var height = $('#cubic-foot-spherical-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var resultA = (Math.pow(height,2) + Math.pow(radius,2))/(2 * height);
                var resultB = (1/3) * Math.PI * Math.pow(height,2) * ((3 * resultA) - height); 

                volume.val(resultB.toFixed(2));
            }

            , calculateConicalVolume: function calculateConicalVolume() {
                //input fields
                var tradius = $('#cubic-foot-conical-top-radius').val();
                var bradius = $('#cubic-foot-conical-bottom-radius').val();
                var height = $('#cubic-foot-conical-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = (1/3) * Math.PI * height * (Math.pow(tradius,2) + (tradius * bradius) + Math.pow(bradius,2));

                volume.val(result.toFixed(2));
            }

            , calculateEllipsoidVolume: function calculateEllipsoidVolume() {
                //input fields
                var axis1 = $('#cubic-foot-ellipsoid-axis-1').val();
                var axis2 = $('#cubic-foot-ellipsoid-axis-2').val();
                var axis3 = $('#cubic-foot-ellipsoid-axis-3').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = (4/3) * Math.PI * axis1 * axis2 * axis3;

                volume.val(result.toFixed(2));
            }

            , calculateSquareVolume: function calculateSquareVolume() {
                //input fields
                var edge = $('#cubic-foot-square-edge').val();
                var height = $('#cubic-foot-square-height').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = (1/3) * Math.pow(edge,2) * height;

                volume.val(result.toFixed(2));
            }

            , calculateTubeVolume: function calculateTubeVolume() {
                //input fields
                var diameter1 = $('#cubic-foot-tube-diameter-1').val();
                var diameter2 = $('#cubic-foot-tube-diameter-2').val();
                var length = $('#cubic-foot-tube-length').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = Math.PI * ((Math.pow(diameter1,2) - Math.pow(diameter2,2))/4) * length;

                volume.val(result.toFixed(2));
            }

            , calculateSlopeVolume: function calculateSlopeVolume() {
                //input fields
                var height = $('#cubic-foot-slope-height').val();
                var depth = $('#cubic-foot-slope-depth').val();
                var width = $('#cubic-foot-slope-width').val();
                //output fields
                var volume = $('#cubic-foot-volume');

                var result = .5 * height * depth * width;

                volume.val(result.toFixed(2));
            }

            , resetAllFields: function resetAllFields() {
                $('.calculator-cubic-foot-input-fields').find('input:text').val('');
                $('.calculator-cubic-foot-output-fields').find('input:text').val('');
            }

            ,	getContext: function getContext()
            {
                return {
                    isSphere: this.isSphere,
                    isCone: this.isCone,
                    isCube: this.isCube,
                    isCylinder: this.isCylinder,
                    isRectangular: this.isRectangular,
                    isCapsule: this.isCapsule,
                    isSpherical: this.isSpherical,
                    isConical: this.isConical,
                    isEllipsoid: this.isEllipsoid,
                    isSquare: this.isSquare,
                    isTube: this.isTube,
                    isSlope: this.isSlope
                };
            }
        });
    });
